<template>
  <div>
    <div class="fa">
      <!-- <div class="bg-error"></div> -->
      <img src="../assets/pic/error1.png" alt="" />
      <p class="error-title" v-if="error">{{ error }}</p>
    </div>
  </div>
</template>
<script>
export default {
  beforeMount() {
    const error = decodeURIComponent(
      decodeURIComponent(window.location.search)
    );
    console.log("error11111111111111111111", error);
    try {
      const data = JSON.parse(error.slice(error.search("=") + 1));
      console.log("error", data);

      if (data.error_code == "0x00") {
        this.error = data.error_msg;
      } else if (data.error_code == "0x01") {
        this.error = data.error_msg;
        setTimeout(() => {
          this.closeDown();
        }, 3000);
      } else if (data.error_code == "0x02") {
        this.error = "未能获取到微信会员卡号，重新点击会员卡提交资料";
        setTimeout(() => {
          window.open(
            "https://mp.weixin.qq.com/bizmall/activatemembercard?action=preshow&&encrypt_card_id=iBpRh5s/WUKOzFY2QOLtqMAVQXlXzUsJybTghPEJrJKNOx4StgyLV7U03VBHOKvt&biz=MzkzMjkwMzk0MA==#wechat_redirect"
          );
        }, 3000);
      } else if (data.error_code == "0x03") {
        this.error = "没有填入手机号码，重新点击会员卡资料提交";
        setTimeout(() => {
          window.open(
            "https://mp.weixin.qq.com/bizmall/activatemembercard?action=preshow&&encrypt_card_id=iBpRh5s/WUKOzFY2QOLtqMAVQXlXzUsJybTghPEJrJKNOx4StgyLV7U03VBHOKvt&biz=MzkzMjkwMzk0MA==#wechat_redirect"
          );
        }, 3000);
      } else if (
        data.return_code == "SUCCESS" &&
        data.result_code == "SUCCESS" &&
        data.resp_data
      ) {
        this.error = JSON.stringify(data);
      } else {
        console.log("212121");
        this.error = data.err_desc;
        console.log("错误信息：", data.err_desc);
      }
    } catch (e) {
      this.error = JSON.stringify(e);
    }
  },
  data() {
    return {
      error: "",
      error2: "",
      error3: "",
    };
  },
  methods: {
    closeDown() {
      try {
        if (WeixinJSBridge) {
          WeixinJSBridge.call("closeWindow");
          android.finishActivity();
          setTimeout(function () {
            //这个可以关闭安卓系统的手机
            document.addEventListener(
              "WeixinJSBridgeReady",
              function () {
                WeixinJSBridge.call("closeWindow");
              },
              false
            );
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style scoped>
.bg-error {
  width: 100px;
  height: 100px;
  margin-top: -200px;
  font-size: 60px;
  color: red;
  /* background-image:url("../assets/pic/error.png"); */
}
.fa {
  /* width: 202px;
  height: 250px; */
  width: calc(100% - 0);
  height: calc(100vh);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* background-color: rgb(255, 168, 168); */
}
img {
  width: 100px;
  height: 100px;
  margin-top: -200px;
}
span {
  width: 200px;
  height: 50px;
  display: inline-block;
  overflow: hidden;
  text-align: center;
  font-size: 24px;
}
.error-title {
  color: #d81e06;
}
.el-button {
  width: 200px;
}
</style>
